// extracted by mini-css-extract-plugin
export default {"ObjAssoc":"ObjAssoc_ObjAssoc__HR5-K","assocLink":"ObjAssoc_assocLink__tQHn6"};